// extracted by mini-css-extract-plugin
module.exports = {"container":"User__container___18HoF","avatar":"User__avatar___6aNx2","username":"User__username___64PE2"};